import { AnaColumn } from "../forms-template.service";

export const unitalocali: AnaColumn[] = [
    {
      itemType: "group", colCount: "6", colSpan: "2", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "id Unità Locale" },
      ]
    },
    {
      itemType: "group", colCount: "3", colSpan: "2", data: [
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione" },
        { type: 'campo', dataField: "indirizzo", dataType: "", caption: "indirizzo" }]
    }];